import { createBrowserRouter, Navigate } from 'react-router-dom';
import { CircularProgress, Stack } from '@mui/material';
import {
  ManageSsccs,
  ReceiptPurchaseOrders,
  ReceiveManifest,
  ReceiveManifestDetails,
  SSCCDetails,
  SearchReprint,
  Settings,
  AdminPanel,
  QmCoordinatorDashboard
} from './pages';
import { Layout } from './components';
import EditPrinters from './pages/admin/printers';
import AdminPanelAccessSettings from './pages/admin/adminPanelAccessSettings';
import QmTestPage from './pages/qm-test';

import ManageLocations from './pages/admin/locations/ManageLocations';
import ManageSubLocations from './pages/admin/locations/ManageSubLocations';
import { useUserDetails } from './contexts/UserDetailsContext';

const isQmTestPageEnabled = process.env.REACT_APP_IS_PROD !== 'true';

function QmCoordinatorRoute() {
  const { userDetails, isLoading } = useUserDetails();

  if (isLoading) {
    return (
      <Stack alignItems="center" justifyContent="center" sx={{ minHeight: '40vh' }}>
        <CircularProgress size={28} />
      </Stack>
    );
  }

  if (typeof userDetails?.qmListRole !== 'string') {
    return <Navigate to="/settings" replace />;
  }

  return <QmCoordinatorDashboard />;
}

export const router = createBrowserRouter([
  {
    path: '/manage-ssccs',
    element: (
      <Layout>
        <ManageSsccs />
      </Layout>
    )
  },
  {
    path: '/manage-ssccs/:id',
    element: (
      <Layout>
        <SSCCDetails />
      </Layout>
    )
  },
  {
    path: '/receipt-purchase-orders',
    element: (
      <Layout>
        <ReceiptPurchaseOrders />
      </Layout>
    )
  },
  {
    path: '/receipt-purchase-orders/:id',
    element: (
      <Layout>
        <ReceiptPurchaseOrders />
      </Layout>
    )
  },
  {
    path: '/receive-manifest',
    element: (
      <Layout>
        <ReceiveManifest />
      </Layout>
    )
  },
  {
    path: '/receive-manifest/:id',
    element: (
      <Layout>
        <ReceiveManifestDetails />
      </Layout>
    )
  },
  {
    path: '/search-reprint',
    element: (
      <Layout>
        <SearchReprint />
      </Layout>
    )
  },
  {
    path: '/admin-panel',
    element: (
      <Layout>
        <AdminPanel />
      </Layout>
    )
  },
  {
    path: '/settings',
    element: (
      <Layout>
        <Settings />
      </Layout>
    )
  },
  {
    path: '/settings/locations',
    element: (
      <Layout>
        <ManageLocations />
      </Layout>
    )
  },
  {
    path: '/settings/location/:id',
    element: (
      <Layout>
        <ManageSubLocations />
      </Layout>
    )
  },
  {
    path: '/settings/printers',
    element: (
      <Layout>
        <EditPrinters />
      </Layout>
    )
  },
  {
    path: '/settings/adminPanelAccessSettings',
    element: (
      <Layout>
        <AdminPanelAccessSettings />
      </Layout>
    )
  },
  {
    path: '/qm-coordinator',
    element: (
      <Layout>
        <QmCoordinatorRoute />
      </Layout>
    )
  },
  ...(isQmTestPageEnabled
    ? [
        {
          path: '/qm-test',
          element: (
            <Layout>
              <QmTestPage />
            </Layout>
          )
        }
      ]
    : []),
  {
    path: '/',
    element: (
      <Layout>
        <ReceiptPurchaseOrders />
      </Layout>
    )
  }
]);
